<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 15:07:43
 * @LastEditors: xgx
 * @LastEditTime: 2023-08-10 15:41:25
-->
<template>
  <div class="login" v-if="!this.$route.query.code">
    <!-- 登录表单 -->
    <div class="left">
         <img style="width:651px;height:679px" src="@/assets/images/logo.png"/>
    </div>
    <div class="right">
        <el-form
      :model="loginForm"
      status-icon
      :rules="rules"
      ref="loginForm"
      class="login-form"
    >
    <p class="title">甘孜州政府综合信息管理平台</p>
      <!-- 账号 -->
      <el-form-item prop="username">
         <div class="username">
            <div class="username-img"><img style="width:22px;height:25px" src="@/assets/images/reng.png"/></div>
            <el-input
              type="text"
              v-model="loginForm.username"
              auto-complete="off"
              placeholder="请输入手机号"
            ></el-input>
         </div>
      </el-form-item>

      <!-- 密码 -->
      <el-form-item prop="password">
         <div class="password">
          <div class="password-img"> <img style="width:25px;height:27px" src="@/assets/images/suo.png"/></div>
             <el-input
              v-model="loginForm.password"
              auto-complete="off"
              placeholder="请输入密码"
              type="password"
            ></el-input>
         </div>
      </el-form-item>
       <p class="bottom">忘记密码？</p>
       <!-- <p class="bottom"><a href="http://59.213.201.192:8081/api/oauth/authorize?scope=read%20write%20openid%20profile%20email%20phone%20address&state=asdaaaaaaqwaeeeeeeeeee&response_type=code&redirect_uri=http%3A%2F%2Fgzz.xiangzhimowen.com%2Fadmin%2F%23%2Flogin&client_id=64915f75b7602ddeb28220fa">自动登录</a></p> -->

       <Verify
        @success="success"
        :mode="'pop'"
        :captchaType="'blockPuzzle'"
            :imgSize="{ width: '330px', height: '155px' }"
            ref="verify"
        ></Verify>

      <!-- 提交按钮 -->
      <el-form-item>
         <div class="submit-box"  @click="useVerify">
             <div class="submit"></div>
             <div class="submit-txt"><strong>登 录</strong></div>
         </div>
      </el-form-item>
     
    </el-form>

    </div>
    
  </div>
</template>

<script>
import {login,selectRoleMenu,getAuth,loginAuto} from '@/api/common.js';
import {phone} from '@/utils/reg.js';
import { message } from 'ant-design-vue';
import { setWaterMark } from "@/utils/waterMark";
import Verify from "@/components/verifition/Verify"; 
import { removeWatermark } from "@/utils/waterMark";
import menusTwo from "@/utils/route";
export default {
  data() {
    return {
      // 登录表单
      loginForm: {
        username: "",
        password: "",
        captchaVerification:"",
      },
      // 验证规则
      rules: {
        username: [
          { required: true, message: "请输入手机号", trigger: "blur" }, 
          {
            validator: phone,
          } 
        ],
        password: { required: true, message: "请输入密码", trigger: "blur" } ,
      },
      accessMenu:[],
      menus:JSON.parse(JSON.stringify(menusTwo)),
    };
  },
  components:{
    Verify,
  },
  mounted(){
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('userInfo');
        sessionStorage.removeItem('menuData');
        sessionStorage.removeItem('siteId');
        sessionStorage.removeItem('siteName');
        sessionStorage.removeItem('toWangZhan');
        removeWatermark();
        getAuth().then((res)=>{
            if(res.code == 0){
                localStorage.setItem('secret',res.data)
            }
        })
        // 走自动登录
        if(this.$route.query.code){
            this.getCodeToken();
            return;
        }
  },
  methods: {
    getCodeToken(){
       let codeArray = [];
        const menus = this.menus;
         loginAuto({
            code:this.$route.query.code,
         }).then((res)=>{
             if(res.code == 0){
                sessionStorage.setItem('token',res.data.token)
                sessionStorage.setItem('userInfo',JSON.stringify(res.data.user))
                sessionStorage.setItem('flagLogin',res.data.flagLogin)
                selectRoleMenu({
                   id:JSON.parse(sessionStorage.getItem('userInfo')).id,
                }).then((res)=>{
                    if(res.code == 0){
                         for (let index = 0; index < res.data.length; index++) {
                                  codeArray.push(res.data[index].code)
                            }
                              for (let indexMen = 0; indexMen < menus.length; indexMen++) {
                   if(codeArray.indexOf( menus[indexMen].code) != -1){
                        menus[indexMen].isShow = true;
                        if(menus[indexMen].children && menus[indexMen].children.length > 0){
                          for (let indexChildren = 0; indexChildren < menus[indexMen].children.length; indexChildren++) {
                              for (let childrenTwo = 0; childrenTwo < menus[indexMen].children[indexChildren].group.length; childrenTwo++) {
                                 if(codeArray.indexOf(menus[indexMen].children[indexChildren].group[childrenTwo].code) != -1){
                                      menus[indexMen].children[indexChildren].group[childrenTwo].isShow = true;
                                      menus[indexMen].children[indexChildren].isShow = true;
                                  }
                              }
                          }
                      }
                   }
                 }
                  sessionStorage.setItem('menuData',JSON.stringify(codeArray))
                  this.accessMenu = JSON.parse(JSON.stringify(menus));
                  // 二次筛选
                  let navData = [];
                  for (let index = 0; index < this.accessMenu.length; index++) {
                    const element = this.accessMenu[index];
                    if(element.isShow){
                        navData.push(element)
                    }
                  }
                  if(navData.length > 0 ){
                      if(navData[0].children){
                            this.$router.push(`${navData[0].children[0].group[0].path}`);
                      }else{
                          this.$router.push(`${navData[0].path}`);
                      }
                  }
                  
                }
            })
                 let name = JSON.parse(sessionStorage.getItem('userInfo'));
                 setWaterMark("", name.name+name.phone.substring(name.phone.length-4));
            }else{
               // message.error(res.msg);
            }
         })
    },
    // 提交登录表单
    success(params){
		       this.loginForm.captchaVerification = params.captchaVerification;
           this.submitForm();
        },
        useVerify(){
           this.$refs.loginForm.validate((valid) => {
              if(valid){
                  this.$refs.verify.show()
              }
            })
            
        },
    submitForm() {
       let codeArray = [];
        const menus = this.menus;
        login(this.loginForm).then((res)=>{
            if(res.code == 0){
                sessionStorage.setItem('token',res.data.token)
                sessionStorage.setItem('userInfo',JSON.stringify(res.data.user))
                sessionStorage.setItem('flagLogin',res.data.flagLogin)
                selectRoleMenu({
                   id:JSON.parse(sessionStorage.getItem('userInfo')).id,
                }).then((res)=>{
                    if(res.code == 0){
                         for (let index = 0; index < res.data.length; index++) {
                                  codeArray.push(res.data[index].code)
                            }
                              for (let indexMen = 0; indexMen < menus.length; indexMen++) {
                   if(codeArray.indexOf( menus[indexMen].code) != -1){
                        menus[indexMen].isShow = true;
                        if(menus[indexMen].children && menus[indexMen].children.length > 0){
                          for (let indexChildren = 0; indexChildren < menus[indexMen].children.length; indexChildren++) {
                              for (let childrenTwo = 0; childrenTwo < menus[indexMen].children[indexChildren].group.length; childrenTwo++) {
                                 if(codeArray.indexOf(menus[indexMen].children[indexChildren].group[childrenTwo].code) != -1){
                                      menus[indexMen].children[indexChildren].group[childrenTwo].isShow = true;
                                      menus[indexMen].children[indexChildren].isShow = true;
                                  }
                              }
                          }
                      }
                   }
                 }
                  sessionStorage.setItem('menuData',JSON.stringify(codeArray))
                  this.accessMenu = JSON.parse(JSON.stringify(menus));
                  // 二次筛选
                  let navData = [];
                  for (let index = 0; index < this.accessMenu.length; index++) {
                    const element = this.accessMenu[index];
                    if(element.isShow){
                        navData.push(element)
                    }
                  }
                  if(navData.length > 0 ){
                      if(navData[0].children){
                            this.$router.push(`${navData[0].children[0].group[0].path}`);
                      }else{
                          this.$router.push(`${navData[0].path}`);
                      }
                  }
                  
                }
            })
                 let name = JSON.parse(sessionStorage.getItem('userInfo'));
                 setWaterMark("", name.name+name.phone.substring(name.phone.length-4));
            }else{
               // message.error(res.msg);
            }
        })
        
    },
  }
};
</script>

<style lang="less" scoped>
.login {
  height: 100%;
  background-color: #fff;
  display: flex;
  display: flex;
  .left{
    flex: 1;
    text-align: center;
    display: flex;
    align-items: center;
  }
  .right{
     flex: 1;
     background: #1785EA;
     display: flex;
     justify-content: center;
     align-items: center;
  }

  .login-form {
    margin: 0 20px;
    overflow: hidden;
    .username,.password{
      width: 450px;
      height: 62px;
      background: #FFFFFF;
      border-radius: 10px;
      display: flex;
      align-items: center;
      border: 1px solid #E8E8E8;
    }
    .submit{
     width: 450px;
      height: 62px;
      background: #00203D;
      opacity: 0.35;
      border-radius: 10px;
      cursor: pointer;
      font-size: 22px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FFFFFF;
    }
    .title{
      height: 32px;
      font-size: 31px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #FFFFFF;
      line-height: 33px;
      text-align: center;
      margin-bottom: 40px;
    }
    .bottom{
      text-align: right;
      margin-top: -13px;
      cursor: pointer;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FFFFFF;
      margin-top: 20px;
      margin-bottom: 36px;
    }
  }
}
/deep/ .el-input__inner{
   background: none;
	  outline: none;
	  border: none;
    width: 100%;
    height: 62px;
    border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}
.username{
  margin-bottom: 10px;
}
.username-img,.password-img{
  width: 61px;
  height: 62px;
  background: #F7F7F7;
  border: 1px solid #E8E8E8;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}
.submit-box{
  position: relative;
  cursor: pointer;
}
.submit-txt{
  position: absolute;
  top:0;
  left: 0;
  justify-content: center;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
}
@media screen and (max-width: 720px) {
  .login .left{
    display: none;
  }
  .login .login-form .username{
    width: 100%;
  }
  .login .login-form .password{
      width: 100%;
  }
  .login .login-form .title{
    font-size: 20px;
  }
  .login .login-form{
    width: 90%;
  }
  .login .login-form .submit{
       width: 100%;
  }
  .login{
    height: 100vh;
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    overflow-x: hidden;
    touch-action:none;
    touch-action:pan-y;
  }
  &::-webkit-scrollbar {
     display: none;
 }
  &::-webkit-scrollbar {
      height: 0;
  }
}
</style>
